/*
--------------------------------------------------------

 Index

--------------------------------------------------------
*/

(function($){

    $.fn.selectLinkOptions = function(options){

        var settings = $.extend({
            option : '.sortNav_selectBox_option',
            tab : '.sortNav_selectBox_ttl',
            layer : '.sortNav_selectLayer'
        }, options);

        var $self = $(this);
        var $options = $(settings.option, this);
        var $tab = $(settings.tab, this);
        var $layer = $(settings.layer, this);

        var $contents = $options.clone(true);
        $layer.html($contents);

        $self.on('click', function(e){

            e.stopPropagation();

            if($tab.hasClass('active')){

                $layer.slideUp('fast');
                $tab.removeClass('active');

            }else{

                $tab.addClass('active');
                $layer.slideDown('fast');

            }

        });

        return this;
    }
})(jQuery);

$(function(){

    // init
    $('.sideMenu_catList').hide();
    // $('.sideMenu_filters_catList').hide();
    $('.selectMenu_category_data').hide();
    $('.selectMenu_category_catList').hide();
    $('.selectMenu_filters_data').hide();

    // PCサイドメニュー アコーディオン
    $('.sideMenu_category').slideAccordion({'bar':'.sideMenu_catTtl', 'contents':'.sideMenu_catList'});
    $('.sideMenu_filters').slideAccordion({'bar':'.sideMenu_filters_catTtl', 'contents':'.sideMenu_filters_catList'});

    // PCサイドメニュー Filters > Color のセレクト
    $('.sideMenu_filters_catList_item_link').on('click', function(){
        $('.sideMenu_filters_colortip_holder').removeClass('selected');
        $(this).find('.sideMenu_filters_colortip_holder').addClass('selected');
        var color = $(this).attr('title');
        // console.log(color);
    });

    // PCサイドメニュー Filters > Price のセレクト
    $('#sort2').selectLinkOptions({
        option:'.sortNav_priceBox_option',
        tab:'.sortNav_priceBox_ttl',
        layer:'.sortNav_priceLayer'
    });
    $('#sort2 .sortNav_priceBox_option a').on('click', function(){
        var label = $(this).text();
        // console.log(label);
        $('#sort2 .sortNav_priceBox_option_list_item').removeClass('current');
        $(this).parent().addClass('current');
        $('#sort2 .sortNav_priceBox_ttl').text(label);
        $('.sortNav_priceLayer').slideUp('fast');
        $('.sortNav_priceBox_ttl').removeClass('active');
        $(this).blur();
    });

    // SPセレクトメニュー Category
    $('.selectMenu_category_ttl').on('click', function(){
        if($(this).hasClass('acc-active')){
            $(this).next().slideUp(300, 'easeInOutQuad', function(){
                $('.selectMenu_category_ttl').removeClass('acc-active');
            });
        }else{
            $('.selectMenu_filters_ttl').next().slideUp(300, 'easeInOutQuad');
            $('.selectMenu_filters_ttl').removeClass('acc-active');
            $(this).addClass('acc-active');
            $(this).next().slideDown(300, 'easeInOutQuad');
        }
    });
    // SPセレクトメニュー アコーディオン
    $('.selectMenu_category_data').slideAccordion({'bar':'.selectMenu_category_catTtl', 'contents':'.selectMenu_category_catList'});

    // SPセレクトメニュー Filters
    $('.selectMenu_filters_ttl').on('click', function(){
        if($(this).hasClass('acc-active')){
            $(this).next().slideUp(300, 'easeInOutQuad', function(){
                $('.selectMenu_filters_ttl').removeClass('acc-active');
            });
        }else{
            $('.selectMenu_category_ttl').next().slideUp(300, 'easeInOutQuad');
            $('.selectMenu_category_ttl').removeClass('acc-active');
            $(this).addClass('acc-active');
            $(this).next().slideDown(300, 'easeInOutQuad');
        }
    });
    // SPセレクトメニュー Filters > Color のセレクト
    $('.selectMenu_filters_catList_item_link').on('click', function(){
        $('.selectMenu_filters_colortip_holder').removeClass('selected');
        $(this).find('.selectMenu_filters_colortip_holder').addClass('selected');
        var color = $(this).attr('title');
        // console.log(color);
        $('#sp_search_cond_color').val(color);
    });

    // SPセレクトメニュー Resetボタン
    $('.selectMenu_filters_nav-reset').on('click', function(){
        // Filters > Color のセレクトOFF
        $('.selectMenu_filters_colortip_holder').removeClass('selected');
        // Resetボタンの処理
        $('select[name=price_range] option').attr('selected', false);
        $('select[name=price_range]').val('');
        $('#filter_area_price_label_sp').html('');
        $('#sp_search_cond_color').val('');
        $('#sp_search_cond_price_range').val('');
    });

    // SPセレクトメニュー Searchボタン
    $('.selectMenu_filters_nav-submit').on('click', function(){
        // Searchボタンの処理
        $('#sp_search_filter').submit();
    });

    // ソートナビゲーション
    $('#sort1').selectLinkOptions();
    /*
    $('#sort1 .sortNav_selectBox_option a').on('click', function(){
        var label = $(this).text();
        // console.log(label);
        $('#sort1 .sortNav_selectBox_option_list_item').removeClass('current');
        $(this).parent().addClass('current');
        $('#sort1 .sortNav_selectBox_ttl').text(label);
        $('.sortNav_selectLayer').slideUp('fast');
        $('.sortNav_selectBox_ttl').removeClass('active');
        //return false;
    });
    */

    // セレクトボックス
    $('.selectArea').on('change', function(){
        var $option = $(this).find('option:selected');
        $('.selectArea_label',$(this)).text($option.text());
        $(this).blur();
    });

    // Movie
    //$('#index-mov').indexMovieEnded();

    //main image slider
    $('#dsn_mainimg_slider').slick({
        slidesToShow: 1,
        infinite: true,
        fade: true,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 1500,
        pauseOnHover: false,
        pauseOnFocus: false,
        speed: 1000
    });

});
/*
$(function(){
    var windowWidth = parseInt($(window).width());
    if (windowWidth >= 768) {
        $("#index-mov")[0].autoplay = true;
    }
});
*/